import React, { useEffect } from 'react'
import { useRedirect } from 'react-admin'
import { useSelector } from 'react-redux'
import { usePermissions } from '@hooks/useHasPermission'

const DashboardLegacy: React.FC = () => {
  const redirectTo = useRedirect()
  const { selectedPropertyId, selectedGroupId } = useSelector((state: any) => state.profile)
  const { GlobalManageCustomers } = usePermissions()

  useEffect(() => {
    if (selectedPropertyId) {
      redirectTo(`/propertyAdd/${selectedPropertyId}`)
    } else if (GlobalManageCustomers && !selectedGroupId) {
      redirectTo('/accountCreate')
    }
  }, [GlobalManageCustomers, redirectTo, selectedGroupId, selectedPropertyId])

  return null
}

export default DashboardLegacy
